package ai.wagemix.net.client

import ai.wagemix.net.models.WMPasswordResetConfirm
import com.fsryan.foundation.net.client.FSRequest
import com.fsryan.foundation.net.client.FSRequestBuilder
import com.fsryan.foundation.net.client.acceptJson
import com.fsryan.foundation.net.client.contentTypeJson
import com.fsryan.foundation.net.client.replacePathParams

/** `POST /api/v1/password-resets/confirm`: sets the new password from a reset link. */
class WMConfirmPasswordResetRequestBuilder:
    FSRequestBuilder<WMConfirmPasswordResetRequestBuilder, WMPasswordResetConfirm>() {

    override fun build(): FSRequest<WMPasswordResetConfirm> {
        method(FSRequest.Method.Post)
        replacePathParams("api", "v1", "password-resets", "confirm")
        acceptJson()
        contentTypeJson()
        return super.build()
    }

    override fun self(): WMConfirmPasswordResetRequestBuilder = this
}
